<cc-box>
  <div box header class="msisdn-label-header">
    {{'MSISDN.LABEL' | translate}}
  </div>
  <div box content class="msisdn-label-content" *ngIf="formWrapper?.form">
    <form [formGroup]="formWrapper.form"
          class="msisdn-label-form"
          (submit)="onSubmit($event)">
      <label translate class="msisdn-label">
        ORDER_NUMBER.WINDOW.LABEL
      </label>

      <div class="input-wrapper">
        <input class="input"
               [placeholder]="placeholderText"
               formControlName="label">
        <cc-input-errors
          [form]="formWrapper.form"
          inputName="label"
          [errors]="[{'required':'ERRORS.REQUIRED'}, {'fourByteCharacter': 'INVALID_CHARACTERS'}, {'unique': 'LABEL_EXISTS'}]"
        >
        </cc-input-errors>
      </div>
    </form>
  </div>
</cc-box>
